import React from 'react';
import { useConsolidationManagementRoutes } from '../../hooks/useConsolidationManagementRoutes';
import { Navbar } from '../navbar/navbar';

export const PredictConsolidationNavbar = () => {
  const { routes } = useConsolidationManagementRoutes();
  return <Navbar routes={routes} />;
};
